import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, Signal, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { GetRequestEventLogResponse } from '@app/generated-api';
import { dateFormatPipe } from '@app/pipes/datepipe';
import {
    MdsButtonComponent,
    MdsDialogActionsComponent,
    MdsDialogComponent,
    MdsDialogContentComponent,
    MdsTableComponent,
} from '@medpacesoftwaredevelopment/designsystem';
import { DateFormat } from '@models/date-format';
import { utc } from 'moment';
@Component({
    selector: 'medpace-view-history-modal',
    standalone: true,
    imports: [
        MdsDialogComponent,
        MdsDialogContentComponent,
        MdsDialogActionsComponent,
        MdsTableComponent,
        MdsButtonComponent,
        MatTableModule,
        dateFormatPipe,
        UpperCasePipe,
    ],
    templateUrl: './view-history-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./view-history-modal.component.scss'],
})
export class MedpaceViewHistoryModalComponent {
    private readonly dialogRef = inject(MatDialogRef<MedpaceViewHistoryModalComponent>);
    private readonly data: Signal<GetRequestEventLogResponse[]> = signal(inject(MAT_DIALOG_DATA));

    public readonly requestStatusLog: Signal<MatTableDataSource<GetRequestEventLogResponse>> = computed(() => {
        const data = this.data();

        if (!data) {
            return new MatTableDataSource([]);
        }

        return new MatTableDataSource(data);
    });

    public readonly DateFormat = DateFormat;

    public readonly columnMap = [
        { header: 'Status', name: 'info' },
        { header: 'Date', name: 'occurredOn' },
        { header: 'Name', name: 'triggeredBy' },
        { header: 'Details', name: 'details' },
    ];
    public readonly requestColumns = this.columnMap.map((row) => row.name);

    closeDialog(): void {
        this.dialogRef.close();
    }

    getLocalDate(timestamp: string) {
        return utc(timestamp).toDate();
    }
}
